import axios from '../api/http'
import QS from 'qs'

/**
 * 登录请求
 */
export function userLogin(data) {
    return axios({
        url: `/Api/Login`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 验证码登录请求
 */
export function PhoneuserLogin(data) {
    return axios({
        url: `/Api/PhoneLogin`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 退出登录请求
 */
export function userOutLogin(data) {
    return axios({
        url: `/Api/ExitLogin`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 获取验证码
 */
export function getVeriCode(data) {
    return axios({
        url: `/Api/GetVeriCode`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 验证验证码
 */
export function verificationCode(data) {
    return axios({
        url: `/Api/VerificationCode`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 找回密码
 */
export function forgetUserPwd(data) {
    return axios({
        url: `/Api/UpdateCodePassWrod`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 修改密码
 */
export function updateUserPwd(data) {
    return axios({
        url: `/Api/UpdateUserPassWord`,
        method: 'post',
        data: QS.stringify(data)
    })
}
/**
 * 获取菜单权限
 */
export function getMenuList(data) {
    return axios({
        url: `/Api/GetMenuList`,
        method: 'post',
        data: QS.stringify(data)
    })
}

/**
 * 获取授权Code
 */
export function getRequestCode(data) {
    return axios({
        url: `/Api/HomeRequestCode`,
        method: 'post',
        data: QS.stringify(data)
    })
}

/**
 * 获取授权Code
 */
export function AutoLogin(data) {
    return axios({
        url: `/Api/PowerLogin_Number`,
        method: 'post',
        data: QS.stringify(data)
    })
}

export function checkToken(data) {
  return axios({
    url: `/Api/CheckToken`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getUserBaseInfo(data) {
  return axios({
    url: `/Api/GetUserBaseInfo`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function changeUserPwd(data) {
  return axios({
    url: `/Api/UpdateCodePassWrod`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function changeUserName(data) {
  return axios({
    url: `/Api/ChangeUserName`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getCollectList(data) {
  return axios({
    url: `/Api/GetCollectsList`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function toCalcelCollect(data) {
  return axios({
    url: `/Api/ToCalcelCollect`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getCompanysList(data) {
  return axios({
    url: `/Api/GetCompanysList`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function deleteCompany(data) {
  return axios({
    url: `/Api/DeleteCompany`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function changeCompany(data) {
  return axios({
    url: `/Api/ChangeCompany`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getUserImg(data) {
  return axios({
    url: `/Api/GetUserImgPath`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getMatchInfo(data) {
  return axios({
    url: `/Api/GetMatchInfo`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function getCityList() {
  return axios({
    url: `/Api/GetCityList`,
    method: 'post'
  })
}

export function getSolrCustomerInfo(data) {
  return axios({
    url: `/Api/GetSolrCustomerInfo`,
    method: 'post',
    data: QS.stringify(data)
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js